import { ModelCategory, ProductionComponentInstance } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties';

export const ProductionComponentInstanceSchema = new ModelSchema<ProductionComponentInstance>(
  'productionComponentInstance',
  {
    category: ModelCategory.ComponentDesign,

    properties: {
      guid: StringProperty.configure({ readOnly: true }),
    },
  },
);
